import MenuObserver from '../menu-observer';
import ElementAttributeObserver from '../../obervers/element-attribute-oberver';


export default class MobileMenu {
	static SELECTOR = '.mobile_nav';

	start() {
		const $ = jQuery;
		//check if mobile menu is presented on the page
		if (!$(MobileMenu.SELECTOR).length) {
			return;
		}
		this.observer = new MenuObserver($(MobileMenu.SELECTOR).get(0));
		this.attachEventListeners();
	}

	attachEventListeners() {
		this.observer.onRender(() => {
			const $ = jQuery;
			if (!coreAccessibility.parentsubmenu_aria_expand_issue_fix) {
				$(MobileMenu.SELECTOR).find('.menu-item-has-children').children('a:eq(0)')
					.removeAttr('aria-expanded')
					.removeAttr('aria-haspopup');
				$(MobileMenu.SELECTOR).find('.menu-item-has-children').children('a:eq(0)').get()
					.forEach((item) => {
						const itemObserver = new ElementAttributeObserver(item);
						itemObserver.onUpdate(() => {
							$(item).removeAttr('aria-expanded').removeAttr('aria-haspopup');
						});
					});
			}

			/**
			 * Re-write the behaviour of changing aria-labels of mobile menu bar
			 */
			$('.mobile_menu_bar').attr({
				'role': 'button', 'aria-expanded': 'false', 'aria-label': 'Open Menu', 'tabindex': 0,
			});
			$('.mobile_menu_bar')
				.off('click')
				.on('click', function() {
					if ($(this).hasClass('a11y-mobile-menu-open')) {
						$(this).removeClass('a11y-mobile-menu-open').attr('aria-expanded', 'false');
						$(this).attr('aria-label', 'Open Menu');
					} else {
						$(this).addClass('a11y-mobile-menu-open').attr('aria-expanded', 'true');
						$(this).attr('aria-label', 'Close Menu');
					}
				});

			/**
			 * Closes mobile menu with the Esc key
			 */
			$(document).keyup((event) => {
				// The ESC key is pressed
				if (event.keyCode === 27) {
					$('.mobile_nav.opened').each(function() {
						if ($(this).find('.mobile_menu_bar:visible').is(':focus')) {
							$(this).find('.mobile_menu_bar:visible').trigger('click');
						} else {
							$(this).find('.mobile_menu_bar:visible').focus();
						}
					});
				}
			});

			/**
			 * Closes mobile menu when it loses focus.
			 */
			$(document).on('focusin', () => {
				$('.mobile_nav.opened').each(function() {
					if (!$(this).find(':focus').length) {
						$(this).find('.mobile_menu_bar:visible').trigger('click');
					}
				});
			});
		});
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/navigation/controllers/mobile-menu.js